const BookedStayFallbackName = Object.freeze({
  ACCOMMODATION: 'Your booked stay',
  BREAKFAST_LOCATION: 'Your hotel',
} as const);

export type BookedStayFallbackName = (typeof BookedStayFallbackName)[keyof typeof BookedStayFallbackName];

export default BookedStayFallbackName;
